import { preloadFonts } from '@yonderland/andes-react';
export default () => preloadFonts;
